import { Route } from 'vue-router';
import store from '@/store/index';

export default function authGuard(to: Route, from: Route, next: any) {
    if ((store.state as any).jwt) {
        next();
    } else {
        next({ name: '403' });
    }
}